/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import { Button } from "@adobe/react-spectrum";
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import { useJsonForms, withJsonFormsLayoutProps } from "@jsonforms/react";
import React, { useContext } from "react";
// Lodash
import { get } from "lodash";

// Redux
import { useSelector } from "react-redux";

import { FormContext } from "../context/FormsContext";

// Utils
import { evaluateContextRule, extractPath } from "../utils/commonUtils";

export const modalCancelRendererTester: RankedTester = rankWith(
  4,
  uiTypeIs("ModalCancel")
);

function ModalCancelRenderer({ uischema, visible, enabled }: RendererProps) {
  const spectrumProps = uischema.options?.spectrumProps;
  const enableContextCallback =
    uischema.options?.enableContextCallback || false;
  const style = uischema.options?.style;
  const label = uischema.options?.label;
  const modalId = uischema.options?.modalId;

  const [_, setContext] = useContext<any>(FormContext);
  const jsonFormContext = useJsonForms();

  const onCancelCallback = jsonFormContext?.config?.onCancelCallback;
  const externalHandlers =
    jsonFormContext?.config?.lifecycleHooks?.externalHandlers;
  const onCloseModal = externalHandlers?.onCloseModal;
  const setContextBack = (dataValue: any) => {
    setContext((oldValues: any) => ({
      ...oldValues,
      data: dataValue,
      config: { ...oldValues?.config, formTouched: false },
    }));
  };
  const buttonPressHandler = () => {
    if (onCloseModal) {
      if (enableContextCallback) {
        onCloseModal({ modalId, setContextBack });
      } else {
        onCloseModal({ modalId });
      }
    }
    onCancelCallback();
  };

  // Determine if the component should be visible and enabled
  let componentVisibility = visible;
  let componentEnabled = enabled;

  // If there is a context rule, evaluate it and use that visibility/enabled rule instead.
  if (uischema.options?.contextRule) {
    // grab the scope from the contextRule
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    // get the redux store state based on the scope provided
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    const contextRuleValidation = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    );
    componentVisibility = contextRuleValidation?.visible;
    componentEnabled = contextRuleValidation?.enabled;
  }

  return (
    <Button
      data-testid="cancel-button"
      variant="secondary"
      isDisabled={!componentEnabled}
      {...spectrumProps}
      UNSAFE_style={{ ...style, cursor: "pointer" }}
      onPress={buttonPressHandler}
      isHidden={!componentVisibility}
    >
      {label}
    </Button>
  );
}

export default withJsonFormsLayoutProps(ModalCancelRenderer);
